import { render, staticRenderFns } from "./CookiesPartial.htm?vue&type=template&id=b670117e&scoped=true&external"
import script from "./CookiesPartial.js?vue&type=script&lang=js&external"
export * from "./CookiesPartial.js?vue&type=script&lang=js&external"
import style0 from "./CookiesPartial.scss?vue&type=style&index=0&id=b670117e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b670117e",
  null
  
)

export default component.exports